import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const messageBodyTextStyles = css`
  margin-right: ${theme.spacing(0.5)};
  text-align: left;

  .mention-loading {
    padding: ${theme.spacing(0, 0.5)};
  }
`;

export const messageBodyTextLinkClass = css`
  color: ${theme.colors.primary50};
  text-decoration: underline;
  word-break: break-word;

  &:hover {
    color: ${theme.colors.primary60};
  }
`;
